import { useEffect } from "react";
import useLayout from "../../../hooks/layout";
import { useOrganization } from "../../context/organization/organization";
import classNames from "./TextSpeed.module.css";
import Slider from "../Slider";

function TextSpeed() {
  const [layout, setLayout] = useLayout();

  const { setOrganization } = useOrganization();
  useEffect(() => {
    if (!setOrganization) {
      return;
    }
    setOrganization((prevState) => {
      if (!prevState) {
        return prevState;
      }
      return {
        ...prevState,
        default_text_translation_setting: {
          ...prevState.default_text_translation_setting,
          text_speed: layout.settings.textSpeed,
        },
      };
    });
  }, [setOrganization, layout.settings]);

  return (
    <div className={classNames.TextSpeed}>
      <label>Text speed</label>
      <div className={classNames.TextSpeedSlider}>
        Live
        <Slider
          min={0}
          max={5}
          value={layout.settings.textSpeed}
          onChange={(value) =>
            setLayout((prevState) => ({
              ...prevState,
              settings: {
                ...prevState.settings,
                textSpeed: value,
              },
            }))
          }
          label="Text size"
        />
        5s
      </div>
    </div>
  );
}

export default TextSpeed;
